/* eslint-disable no-class-assign */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import FormTextContainer from '../../redux/containers/FormTextContainer';
import ContactUsValidator from '../../common/validation/ContactUsValidator';
import ContactUsService from '../../services/ContactUsService';
import './ContactUs.scss';
import FormSelect from '../form/FormSelect/FormSelect';
import CustomField from '../form/CustomField';
import ContactUsUtils from './ContactUsUtils';
import Categories from './ContactUsCategories.json';
import WidgetMode from './WidgetMode';
import PageHeader from '../PageHeader/PageHeader';

class ContactUs extends React.Component {

  componentDidMount() {
    const type = this.props.params.type;
    const subtype = this.props.params.subtype;
    let name = this.props.params.name;
    if (this.props.location.query.name) {
      name = this.props.location.query.name;
    }
    let email = this.props.params.customersEmail;
    if (this.props.location.query.email) {
      email = this.props.location.query.email;
    }
    if (type) {
      this.props.change('caseCategory', type);
    }
    if (subtype) {
      this.props.change('caseSubcategory', subtype);
    }
    if (email) {
      this.props.change('email', email);
    }
    if (name) {
      this.props.change('name', name);
    }
  }

  render() {
    const { handleSubmit, caseCategory, caseSubcategory } = this.props;
    return (<main>
      <PageHeader title={'Get in touch'} />
      <form onSubmit={handleSubmit} className="contact-us-form">
        <div className="container">
          {map(ContactUsUtils.getAboveCustomFields(caseCategory, caseSubcategory), field => (
            <div key={field.id} className="row">
              <div className="col-sm-12">
                <CustomField {...field} {...this.props} />
              </div>
            </div>
          ))
          }
          {ContactUsUtils.getAboveCustomFields(caseCategory, caseSubcategory).length === 0 &&
          <div className="row">
            <div className="col-xs-12 contact-us-subheading">
              Enter your details below to tell us a bit more about you
            </div>
          </div>
          }
          <div className="row">
            <div className="col-sm-12">
              <FormTextContainer
                name="name"
                label="Name"
                placeholder="Name"
                autotestClass="autotest-name"
                maxLength={80}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <FormTextContainer
                name="email"
                label="Email"
                placeholder="Email"
                autotestClass="autotest-email"
                maxLength={80}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <FormTextContainer
                name="phone"
                label="Contact number"
                placeholder="Contact number"
                autotestClass="autotest-phone"
                maxLength={40}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="contact-us-subheading">How can we help?</div>
              <Field
                label="I'm contacting Skinny about"
                id="caseCategory"
                name="caseCategory"
                component={FormSelect}
              >
                {map(Categories, category => (
                  <option
                    value={category.value}
                    key={category.value}
                  >{category.name}</option>
                ))}
              </Field>
            </div>
          </div>
          {ContactUsUtils.getSubCategories(caseCategory) &&
          <div className="row">
            <div className="col-sm-12">
              <Field
                label="Choose from these options"
                id="caseSubcategory"
                name="caseSubcategory"
                component={FormSelect}
              >
                {map(ContactUsUtils.getSubCategories(caseCategory), category => (
                  <option value={category.value} key={category.value}>{category.name}</option>
                ))}
              </Field>
            </div>
          </div>
          }
          {map(ContactUsUtils.getCustomFields(caseCategory, caseSubcategory), (field) => {
            // row divs had 1 pixel total height even when the CustomField inside rendered null
            // so I moved the if statements to here from the components
            if (field.fieldType === 'modem-lights' && this.props.widgetMode !== WidgetMode.hg659.name) {
              // ModemLights widget only shown for HG659 modem
              return null;
            }
            if (field.fieldType === 'smart-modem-status' && this.props.widgetMode !== WidgetMode.smartModem.name) {
              // SmartModemStatus widget only shown for the Skinny 'Smart Modem'.
              return null;
            }
            return (
              <div key={field.id} className="row">
                <div className="col-sm-12">
                  <CustomField {...field} {...this.props} />
                </div>
              </div>
            );
          })
          }
        </div>
      </form>
    </main>);
  }
}

ContactUs = reduxForm({
  form: 'contactUs', // a unique name for this form
  validate: ContactUsValidator,
  onSubmit: values => ContactUsService.submitCase(values),
})(ContactUs);

// Decorate with connect to read form values
const selector = formValueSelector('contactUs'); // <-- same as form name

ContactUs = connect(
  (state) => {
    // can select values individually
    const caseCategory = selector(state, 'caseCategory');
    const caseSubcategory = selector(state, 'caseSubcategory');
    const widgetMode = selector(state, 'widgetMode');
    return {
      caseCategory,
      caseSubcategory,
      widgetMode
    };
  }
)(ContactUs);

ContactUs.propTypes = {
  caseCategory: PropTypes.string,
  caseSubcategory: PropTypes.string,
  params: PropTypes.shape(
    {
      type: PropTypes.string,
      subtype: PropTypes.string,
      customersEmail: PropTypes.string,
      name: PropTypes.string
    }
  ),
  handleSubmit: PropTypes.func,
  change: PropTypes.func,
  widgetMode: PropTypes.string,
  location: PropTypes.shape(
    {
      query: PropTypes.object
    }
  )
};

export default ContactUs;



/** WEBPACK FOOTER **
 ** ./src/components/ContactUs/ContactUs.js
 **/